import { required, Validator } from '@/entities/validation';
import { EntityFolderEdit, EntityFolder } from './model';

export const validate: Validator<EntityFolder | EntityFolderEdit> = record => [
  ...required(record.title, 'title'),
];
